import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const http = axios.create({ baseURL: API, withCredentials: true });

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const authApi = {
  register: (payload) => http.post("/auth/register", payload).then((r) => r.data),
  login: (payload) => http.post("/auth/login", payload).then((r) => r.data),
  logout: () => http.post("/auth/logout").then((r) => r.data),
  me: () => http.get("/auth/me").then((r) => r.data),
  changePassword: (payload) => http.post("/auth/change-password", payload).then((r) => r.data),
};

export const cdssApi = {
  followupQuestions: (body) => http.post("/cdss/followup-questions", body).then((r) => r.data),
  tentative: (body) => http.post("/cdss/tentative", body).then((r) => r.data),
  suggestedSigns: (body) => http.post("/cdss/suggested-signs", body).then((r) => r.data),
  differentials: (body) => http.post("/cdss/differentials", body).then((r) => r.data),
  investigations: (body) => http.post("/cdss/investigations", body).then((r) => r.data),
  final: (body) => http.post("/cdss/final", body).then((r) => r.data),
  readReport: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return http.post("/cdss/read-report", fd).then((r) => r.data);
  },
  readImage: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return http.post("/cdss/read-image", fd).then((r) => r.data);
  },
  finalReportPdf: (body) => http.post("/cdss/final-report-pdf", body, { responseType: "blob" }).then((r) => r.data),
  prescriptionPdf: (body) => http.post("/cdss/prescription-pdf", body, { responseType: "blob" }).then((r) => r.data),
  caseSheetPdf: (body) => http.post("/cdss/case-sheet-pdf", body, { responseType: "blob" }).then((r) => r.data),
};

export const casesApi = {
  list: () => http.get("/cases").then((r) => r.data),
  get: (id) => http.get(`/cases/${id}`).then((r) => r.data),
  save: (body) => http.post("/cases", body).then((r) => r.data),
  remove: (id) => http.delete(`/cases/${id}`).then((r) => r.data),
  exportPdf: () => http.post("/cases/export-pdf", {}, { responseType: "blob" }).then((r) => r.data),
};

export default http;
